import clsx from 'clsx'

interface RoomBrandProps {
  name: string
  variant?: 'header' | 'overlay'
  versionLabel?: string
}

function getMonogram(name: string) {
  const words = name.trim().split(/\s+/).filter(Boolean)
  if (words.length === 1) return words[0].slice(0, 3).toUpperCase()
  return words.slice(0, 3).map((word) => word[0]).join('').toUpperCase()
}

export function RoomBrand({
  name,
  variant = 'header',
  versionLabel,
}: RoomBrandProps) {
  return (
    <div
      className={clsx('room-brand', `room-brand--${variant}`)}
      aria-label={`${name} private viewing room`}
    >
      <span className="room-brand__mark" aria-hidden="true">
        <span>{getMonogram(name)}</span>
      </span>
      <span className="room-brand__copy">
        <span className="room-brand__eyebrow">Private viewing room</span>
        <strong className="room-brand__name" title={name}>{name}</strong>
      </span>
      {versionLabel && (
        <span className="room-brand__version">{versionLabel}</span>
      )}
    </div>
  )
}
